/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth/route'
import { Route as appRouteImport } from './routes/(app)/route'
import { Route as IndexImport } from './routes/index'
import { Route as PlaygroundStepperImport } from './routes/playground/stepper'
import { Route as ConfirmationTokenImport } from './routes/confirmation.$token'
import { Route as AuthVerificationImport } from './routes/auth/verification'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as AuthRegisterImport } from './routes/auth/register'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthForgotPasswordImport } from './routes/auth/forgot-password'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as AuthNewPasswordTokenImport } from './routes/auth/new-password.$token'
import { Route as appTrackTrackidIndexImport } from './routes/(app)/track/$trackid/index'
import { Route as appTrackTrackidSpeakingQuizidImport } from './routes/(app)/track/$trackid/speaking.$quizid'
import { Route as appTrackTrackidQuizV2QuizidImport } from './routes/(app)/track/$trackid/quiz-v2.$quizid'
import { Route as appTrackTrackidLessonLessonidImport } from './routes/(app)/track/$trackid/lesson.$lessonid'
import { Route as appTrackTrackidExamExamidImport } from './routes/(app)/track/$trackid/exam.$examid'

// Create/Update Routes

const AuthRouteRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const appRouteRoute = appRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PlaygroundStepperRoute = PlaygroundStepperImport.update({
  id: '/playground/stepper',
  path: '/playground/stepper',
  getParentRoute: () => rootRoute,
} as any)

const ConfirmationTokenRoute = ConfirmationTokenImport.update({
  id: '/confirmation/$token',
  path: '/confirmation/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthVerificationRoute = AuthVerificationImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthRegisterRoute = AuthRegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthNewPasswordTokenRoute = AuthNewPasswordTokenImport.update({
  id: '/new-password/$token',
  path: '/new-password/$token',
  getParentRoute: () => AuthRouteRoute,
} as any)

const appTrackTrackidIndexRoute = appTrackTrackidIndexImport.update({
  id: '/track/$trackid/',
  path: '/track/$trackid/',
  getParentRoute: () => appRouteRoute,
} as any)

const appTrackTrackidSpeakingQuizidRoute =
  appTrackTrackidSpeakingQuizidImport.update({
    id: '/track/$trackid/speaking/$quizid',
    path: '/track/$trackid/speaking/$quizid',
    getParentRoute: () => appRouteRoute,
  } as any)

const appTrackTrackidQuizV2QuizidRoute =
  appTrackTrackidQuizV2QuizidImport.update({
    id: '/track/$trackid/quiz-v2/$quizid',
    path: '/track/$trackid/quiz-v2/$quizid',
    getParentRoute: () => appRouteRoute,
  } as any)

const appTrackTrackidLessonLessonidRoute =
  appTrackTrackidLessonLessonidImport.update({
    id: '/track/$trackid/lesson/$lessonid',
    path: '/track/$trackid/lesson/$lessonid',
    getParentRoute: () => appRouteRoute,
  } as any)

const appTrackTrackidExamExamidRoute = appTrackTrackidExamExamidImport.update({
  id: '/track/$trackid/exam/$examid',
  path: '/track/$trackid/exam/$examid',
  getParentRoute: () => appRouteRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof AuthRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof AuthRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterImport
      parentRoute: typeof AuthRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthRouteImport
    }
    '/auth/verification': {
      id: '/auth/verification'
      path: '/verification'
      fullPath: '/auth/verification'
      preLoaderRoute: typeof AuthVerificationImport
      parentRoute: typeof AuthRouteImport
    }
    '/confirmation/$token': {
      id: '/confirmation/$token'
      path: '/confirmation/$token'
      fullPath: '/confirmation/$token'
      preLoaderRoute: typeof ConfirmationTokenImport
      parentRoute: typeof rootRoute
    }
    '/playground/stepper': {
      id: '/playground/stepper'
      path: '/playground/stepper'
      fullPath: '/playground/stepper'
      preLoaderRoute: typeof PlaygroundStepperImport
      parentRoute: typeof rootRoute
    }
    '/auth/new-password/$token': {
      id: '/auth/new-password/$token'
      path: '/new-password/$token'
      fullPath: '/auth/new-password/$token'
      preLoaderRoute: typeof AuthNewPasswordTokenImport
      parentRoute: typeof AuthRouteImport
    }
    '/(app)/track/$trackid/': {
      id: '/(app)/track/$trackid/'
      path: '/track/$trackid'
      fullPath: '/track/$trackid'
      preLoaderRoute: typeof appTrackTrackidIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/track/$trackid/exam/$examid': {
      id: '/(app)/track/$trackid/exam/$examid'
      path: '/track/$trackid/exam/$examid'
      fullPath: '/track/$trackid/exam/$examid'
      preLoaderRoute: typeof appTrackTrackidExamExamidImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/track/$trackid/lesson/$lessonid': {
      id: '/(app)/track/$trackid/lesson/$lessonid'
      path: '/track/$trackid/lesson/$lessonid'
      fullPath: '/track/$trackid/lesson/$lessonid'
      preLoaderRoute: typeof appTrackTrackidLessonLessonidImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/track/$trackid/quiz-v2/$quizid': {
      id: '/(app)/track/$trackid/quiz-v2/$quizid'
      path: '/track/$trackid/quiz-v2/$quizid'
      fullPath: '/track/$trackid/quiz-v2/$quizid'
      preLoaderRoute: typeof appTrackTrackidQuizV2QuizidImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/track/$trackid/speaking/$quizid': {
      id: '/(app)/track/$trackid/speaking/$quizid'
      path: '/track/$trackid/speaking/$quizid'
      fullPath: '/track/$trackid/speaking/$quizid'
      preLoaderRoute: typeof appTrackTrackidSpeakingQuizidImport
      parentRoute: typeof appRouteImport
    }
  }
}

// Create and export the route tree

interface appRouteRouteChildren {
  appTrackTrackidIndexRoute: typeof appTrackTrackidIndexRoute
  appTrackTrackidExamExamidRoute: typeof appTrackTrackidExamExamidRoute
  appTrackTrackidLessonLessonidRoute: typeof appTrackTrackidLessonLessonidRoute
  appTrackTrackidQuizV2QuizidRoute: typeof appTrackTrackidQuizV2QuizidRoute
  appTrackTrackidSpeakingQuizidRoute: typeof appTrackTrackidSpeakingQuizidRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appTrackTrackidIndexRoute: appTrackTrackidIndexRoute,
  appTrackTrackidExamExamidRoute: appTrackTrackidExamExamidRoute,
  appTrackTrackidLessonLessonidRoute: appTrackTrackidLessonLessonidRoute,
  appTrackTrackidQuizV2QuizidRoute: appTrackTrackidQuizV2QuizidRoute,
  appTrackTrackidSpeakingQuizidRoute: appTrackTrackidSpeakingQuizidRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerificationRoute: typeof AuthVerificationRoute
  AuthNewPasswordTokenRoute: typeof AuthNewPasswordTokenRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerificationRoute: AuthVerificationRoute,
  AuthNewPasswordTokenRoute: AuthNewPasswordTokenRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof appRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verification': typeof AuthVerificationRoute
  '/confirmation/$token': typeof ConfirmationTokenRoute
  '/playground/stepper': typeof PlaygroundStepperRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/track/$trackid': typeof appTrackTrackidIndexRoute
  '/track/$trackid/exam/$examid': typeof appTrackTrackidExamExamidRoute
  '/track/$trackid/lesson/$lessonid': typeof appTrackTrackidLessonLessonidRoute
  '/track/$trackid/quiz-v2/$quizid': typeof appTrackTrackidQuizV2QuizidRoute
  '/track/$trackid/speaking/$quizid': typeof appTrackTrackidSpeakingQuizidRoute
}

export interface FileRoutesByTo {
  '/': typeof appRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verification': typeof AuthVerificationRoute
  '/confirmation/$token': typeof ConfirmationTokenRoute
  '/playground/stepper': typeof PlaygroundStepperRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/track/$trackid': typeof appTrackTrackidIndexRoute
  '/track/$trackid/exam/$examid': typeof appTrackTrackidExamExamidRoute
  '/track/$trackid/lesson/$lessonid': typeof appTrackTrackidLessonLessonidRoute
  '/track/$trackid/quiz-v2/$quizid': typeof appTrackTrackidQuizV2QuizidRoute
  '/track/$trackid/speaking/$quizid': typeof appTrackTrackidSpeakingQuizidRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/verification': typeof AuthVerificationRoute
  '/confirmation/$token': typeof ConfirmationTokenRoute
  '/playground/stepper': typeof PlaygroundStepperRoute
  '/auth/new-password/$token': typeof AuthNewPasswordTokenRoute
  '/(app)/track/$trackid/': typeof appTrackTrackidIndexRoute
  '/(app)/track/$trackid/exam/$examid': typeof appTrackTrackidExamExamidRoute
  '/(app)/track/$trackid/lesson/$lessonid': typeof appTrackTrackidLessonLessonidRoute
  '/(app)/track/$trackid/quiz-v2/$quizid': typeof appTrackTrackidQuizV2QuizidRoute
  '/(app)/track/$trackid/speaking/$quizid': typeof appTrackTrackidSpeakingQuizidRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verification'
    | '/confirmation/$token'
    | '/playground/stepper'
    | '/auth/new-password/$token'
    | '/track/$trackid'
    | '/track/$trackid/exam/$examid'
    | '/track/$trackid/lesson/$lessonid'
    | '/track/$trackid/quiz-v2/$quizid'
    | '/track/$trackid/speaking/$quizid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verification'
    | '/confirmation/$token'
    | '/playground/stepper'
    | '/auth/new-password/$token'
    | '/track/$trackid'
    | '/track/$trackid/exam/$examid'
    | '/track/$trackid/lesson/$lessonid'
    | '/track/$trackid/quiz-v2/$quizid'
    | '/track/$trackid/speaking/$quizid'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/auth'
    | '/auth/callback'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/auth/verification'
    | '/confirmation/$token'
    | '/playground/stepper'
    | '/auth/new-password/$token'
    | '/(app)/track/$trackid/'
    | '/(app)/track/$trackid/exam/$examid'
    | '/(app)/track/$trackid/lesson/$lessonid'
    | '/(app)/track/$trackid/quiz-v2/$quizid'
    | '/(app)/track/$trackid/speaking/$quizid'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ConfirmationTokenRoute: typeof ConfirmationTokenRoute
  PlaygroundStepperRoute: typeof PlaygroundStepperRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ConfirmationTokenRoute: ConfirmationTokenRoute,
  PlaygroundStepperRoute: PlaygroundStepperRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(app)",
        "/auth",
        "/confirmation/$token",
        "/playground/stepper"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/(app)": {
      "filePath": "(app)/route.tsx",
      "children": [
        "/(app)/track/$trackid/",
        "/(app)/track/$trackid/exam/$examid",
        "/(app)/track/$trackid/lesson/$lessonid",
        "/(app)/track/$trackid/quiz-v2/$quizid",
        "/(app)/track/$trackid/speaking/$quizid"
      ]
    },
    "/auth": {
      "filePath": "auth/route.tsx",
      "children": [
        "/auth/callback",
        "/auth/forgot-password",
        "/auth/login",
        "/auth/register",
        "/auth/reset-password",
        "/auth/verification",
        "/auth/new-password/$token"
      ]
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx",
      "parent": "/auth"
    },
    "/auth/forgot-password": {
      "filePath": "auth/forgot-password.tsx",
      "parent": "/auth"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx",
      "parent": "/auth"
    },
    "/auth/register": {
      "filePath": "auth/register.tsx",
      "parent": "/auth"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx",
      "parent": "/auth"
    },
    "/auth/verification": {
      "filePath": "auth/verification.tsx",
      "parent": "/auth"
    },
    "/confirmation/$token": {
      "filePath": "confirmation.$token.tsx"
    },
    "/playground/stepper": {
      "filePath": "playground/stepper.tsx"
    },
    "/auth/new-password/$token": {
      "filePath": "auth/new-password.$token.tsx",
      "parent": "/auth"
    },
    "/(app)/track/$trackid/": {
      "filePath": "(app)/track/$trackid/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/track/$trackid/exam/$examid": {
      "filePath": "(app)/track/$trackid/exam.$examid.tsx",
      "parent": "/(app)"
    },
    "/(app)/track/$trackid/lesson/$lessonid": {
      "filePath": "(app)/track/$trackid/lesson.$lessonid.tsx",
      "parent": "/(app)"
    },
    "/(app)/track/$trackid/quiz-v2/$quizid": {
      "filePath": "(app)/track/$trackid/quiz-v2.$quizid.tsx",
      "parent": "/(app)"
    },
    "/(app)/track/$trackid/speaking/$quizid": {
      "filePath": "(app)/track/$trackid/speaking.$quizid.tsx",
      "parent": "/(app)"
    }
  }
}
ROUTE_MANIFEST_END */
